import React from 'react';

import CustomTableBody from './../../reusable/CustomTableBody/CustomTableBody.index.jsx';
import InfiniteScrollTable from './../../reusable/InfiniteScrollTable/InfiniteScrollTable.index.jsx';
import {
    Cell,
    LinkCell,
    EmailCell,
    ImageCell
} from './../../reusable/CustomTableBody/templates/CustomTableBody.predefinedCellTypes.jsx';


class TableTestPage extends React.Component {

    render() {

        let rowsModel = [
            {
                fieldId:   '_id',
                fieldType: 'string',
                classes:   'row-id bolded'
            },
            {
                fieldId:   'name',
                fieldType: 'string',
                format:    '<b>%v</b>'
            },
            {
                fieldId:   'age',
                fieldType: 'number',
                format:    '%v years old'
            },
            {
                fieldId:       'isActive',
                fieldType:     'boolean',
                format:        '<mark>%v</mark>',
                booleanValues: 'Yes|No'
            },
            {
                fieldId:   'email',
                fieldType: EmailCell,
                classes:   'user-email'
            },
            {
                fieldId:   'picture',
                fieldType: LinkCell,
                classes:   'app-link website-link'
            },
            {
                fieldId:   'picture',
                fieldType: ImageCell,
                altText:   function(value, tableData, i, j) {
                    return tableData[i].name + ' avatar';
                }
            },
            {
                fieldId:   'company',
                fieldType: Cell,
                format:    function(value, tableData, i, j) {
                    return (<span className={'company-' + i + '-' + j}><i>{value}</i></span>);
                }
            },
            {
                fieldId:   'counterfeit',
                fieldType: 'number'
            }
        ];
        
        return (
            <InfiniteScrollTable tableId="test-table-1">
                <thead>
                    <tr>
                        <th>User ID</th>
                        <th>Name</th>
                        <th>Age</th>
                        <th>Contributor</th>
                        <th>E-mail</th>
                        <th>Website</th>
                        <th>Avatar</th>
                        <th>Company</th>
                        <th>Other</th>
                    </tr>
                </thead>
                <CustomTableBody tableId="test-table-1"
                                 url="/api/table-data.json"
                                 rowsModel={rowsModel}
                                 startPageNumber="0"
                                 pageSize="100"
                                 defaultSortBy="name"
                                 defaultDirection="asc" />
            </InfiniteScrollTable>
        );

    }

}

export default TableTestPage;


// WEBPACK FOOTER //
// ./src/scripts/pages/TableTestPage/TableTestPage.index.jsx